/* eslint-disable camelcase */
export const LEGACY_SERVICE_HANDLE_MAP = {
  marketing: 'marketing_and_sales',
  visual_photo_editing: 'photo_editing',
  small_setup_tasks_expert_guidance: 'expert_guidance',
  setup_and_design_store_tweaks: 'store_tweaks',
};
/* eslint-enable camelcase */
